<script setup>
import { ref, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import Loading from "@/components/Loading";
import { useStore } from "vuex";
import { useBranding } from "@/utils/branding";

const isLoading = ref(false);

const router = useRouter();
const route = useRoute();
const store = useStore();

// Get branding information
const { brandLogo, brandName } = useBranding();

// Get environment from Vuex store

const isDetailCompanyPage = computed(() => route.name === "DetailCompany");
const isDocumentCompanyPage = computed(() => route.name === "DocumentCompany");
const isBankCompanyPage = computed(() => route.name === "BankCompany");

const handleClose = () => {
  store.state.showTransferNavbar = false;
  router.push({ name: "Home" });
};
</script>

<template>
  <nav class="navbar">
    <div class="container-fluid">
      <div class="navbar-left">
        <router-link class="logo-container" to="/">
          <img :src="brandLogo" :alt="brandName" />
          <span
            v-if="
              isDetailCompanyPage || isDocumentCompanyPage || isBankCompanyPage
            "
            class="page-title"
            >Verified Account</span
          >
        </router-link>

        <!-- Environment Toggle - positioned to align with main content -->
      </div>

      <div class="navbar-right">
        <div
          class="fs-6 fw-normal"
          style="
            color: #ff3b30;
            font-family: Inter;
            line-height: normal;
            cursor: pointer;
          "
          @click="handleClose"
        >
          Close
        </div>
      </div>
    </div>
    <Loading :isLoading="isLoading" />
  </nav>
</template>

<style scoped>
.navbar {
  position: relative;
  overflow: visible;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  padding: 12px 24px;
  background-color: #ffffff;
  border-bottom: 1px solid #e9ecef;
}

.container-fluid {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.navbar-left {
  display: flex;
  align-items: center;
  gap: 24px;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #212529;
}

.navbar-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.search-container {
  position: relative;
}

.search-input {
  padding: 8px 12px 8px 36px;
  border: 1px solid #ced4da;
  border-radius: 20px;
  font-size: 14px;
  width: 240px;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
}

.environment-toggle-wrapper {
  display: flex;
  align-items: center;
  margin-left: auto;
  padding-left: 40px;
  margin-top: 4px;
}

.environment-toggle {
  display: flex;
  align-items: center;
}

.environment-toggle .btn-group {
  display: flex;
}

.environment-toggle .btn {
  font-size: 12px;
  padding: 6px 14px;
  border-radius: 4px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.environment-toggle .btn:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.environment-toggle .btn:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
}

.notification-icon {
  font-size: 18px;
  color: #6c757d;
  cursor: pointer;
}

.user-profile {
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}

.avatar {
  width: 32px;
  height: 32px;
  background-color: #6c757d;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
}

.arrow-icon {
  font-size: 12px;
  color: #6c757d;
}

.logo-container {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-container img {
  height: 40px;
}

.dropdown-menu {
  position: absolute;
  top: 40px;
  right: 0;
  background-color: #ffffff;
  border: 1px solid #ced4da;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 150px;
  z-index: 1050;
  display: block;
}

.dropdown-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.dropdown-menu li {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  color: #212529;
}

.dropdown-menu li:hover {
  background-color: #f8f9fa;
}

.dropdown-menu li a {
  text-decoration: none;
  color: inherit;
  display: block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .navbar-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
  }

  .environment-toggle-wrapper {
    order: 2;
    margin-left: 0;
    padding-left: 0;
    width: 100%;
    justify-content: flex-start;
    margin-top: 8px;
  }

  .logo-container {
    order: 1;
  }

  .navbar-right {
    flex-wrap: wrap;
    gap: 8px;
  }

  .search-container {
    order: 3;
    width: 100%;
    margin-top: 8px;
  }

  .search-input {
    width: 100%;
  }

  .notification-icon {
    order: 1;
  }

  .user-profile {
    order: 2;
  }
}
</style>
